import { Button, Spinner } from '@myhealth-raccoon/components';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useBookingFlowStep } from 'src/hooks/useBookingFlowStep';
import { useAppointmentTypeSelector, useDoctorSelector } from "src/hooks/useAsyncSelector";
import { BackButton } from "src/components/BackButton";
import { StickyBottomBar } from 'src/components/StickyBottomBar';
import { ContentContainer } from 'src/components/ContentContainer';
import { b64DecodeUnicode, innerHtml } from 'src/utils/html';
import { isAfterHours, isFaceToFace } from 'src/utils/appointmentTypes';
import { useDispatch, useSelector } from 'src/store';
import { appointmentSlice } from 'src/store/appointment';

export function PreScreening() {
    useBookingFlowStep(1);
    const navigate = useNavigate();
    const { data: doctor, ...doctorRequest } = useDoctorSelector();
    const { data: appointmentType, ...appointmentTypeRequest } = useAppointmentTypeSelector();

    // clear previous appointment from sessionStorage
    const dispatch = useDispatch();
    const reservedBooking = useSelector(state => state.appointment.reservedBooking);
    useEffect(() => {
        if (reservedBooking) {
            dispatch(appointmentSlice.actions.removeReservedBooking())
        }
    }, [dispatch, reservedBooking]);

    return <>
        <ContentContainer className='flex-1 lg:flex-none'>
            <h1 className='text-2xl text-gray-900 font-semibold mb-2.5'>Please note</h1>

            <div className='flex flex-col gap-8'>
                <p className='text-base'>Please review the policies below to continue your booking</p>

                {appointmentType && !isFaceToFace(appointmentType) && <><p><strong>This is a phone consultation only; please do not come to the clinic.</strong></p></>}

                {appointmentType && isAfterHours(appointmentType) && <>
                    <p>
                        Your doctor will aim to contact you within an hour of your scheduled appointment time. This service is exclusively for existing patients of the clinic and is intended only for urgent issues.
                    </p>
                    <p className='text-error-500'>For some medical emergencies it is more appropriate to attend the Hospital Emergency Department and the doctor reserves the right direct you to do so if medically indicated.</p>
                </>}

                {appointmentTypeRequest.isLoading
                    ? <span className="w-32 opacity-25 block bg-current rounded-full h-[0.5em]"></span>
                    : appointmentType && appointmentType.questionRequired && appointmentType.apptQuestionInBase64
                        ? <div>
                            <div className='prose-sm' {...innerHtml(b64DecodeUnicode(appointmentType.apptQuestionInBase64)?.replace(/text-center/g, "text-left"))} />
                        </div>
                        : ''
                }
                {doctorRequest.isLoading
                    ? <span className="w-32 opacity-25 block bg-current rounded-full h-[0.5em]"></span>
                    : doctor && doctor.enableDoctorNotice && doctor.doctorNotice
                        ? <div>
                            <h3 className='text-xl text-gray-600 font-semibold'>Doctor notice</h3>
                            <div className='prose-sm' {...innerHtml(doctor.doctorNotice?.replace(/text-center/g, "text-left"))} />
                        </div>
                        : ''
                }

            </div>
        </ContentContainer>
        <StickyBottomBar>
            <BackButton
                onClick={() => {
                    if (window.opener) {
                        window.close();
                    } else {
                        navigate(-1);
                    }
                }}
                label="Back" />
            <Button className='flex-1 text-center'
                to='/app/personal-details'
                disabled={appointmentTypeRequest.isLoading || doctorRequest.isLoading}
            >
                {appointmentTypeRequest.isLoading || doctorRequest.isLoading
                    ? <Spinner className='inline-block' size='xs' />
                    : "Accept and continue"
                }
            </Button>
        </StickyBottomBar>
    </>
}